import Vue from 'vue'
export const setGenerated = (toUpdate, fiche, value = true) => {
  if (Array.isArray(fiche)) {
    fiche.forEach(el => {
      if (!toUpdate[el.onglet].rows) {
        toUpdate[el.onglet].rows = []
      }
      if (toUpdate[el.onglet].rows[el.ligne]) {
        toUpdate[el.onglet].rows[el.ligne] = { ...toUpdate[el.onglet].rows[el.ligne], fiche: value ? el.id : null }
      } else {
        toUpdate[el.onglet].rows[el.ligne] = { fiche: value ? el.id : null }
      }
      Vue.set(toUpdate[el.onglet].rows[el.ligne], 'colAddedToFiche', [])
      toUpdate[el.onglet].rows[el.ligne].colAddedToFiche = ['H1']
    })
    return toUpdate
  }
  if (!toUpdate[fiche.onglet].rows) {
    toUpdate[fiche.onglet].rows = []
  }
  if (toUpdate[fiche.onglet].rows[fiche.ligne]) {
    toUpdate[fiche.onglet].rows[fiche.ligne] = { ...toUpdate[fiche.onglet].rows[fiche.ligne], fiche: value ? fiche.id || fiche.ficheId : null }
  } else {
    toUpdate[fiche.onglet].rows[fiche.ligne] = { fiche: value ? fiche.id || fiche.ficheId : null }
  }
  Vue.set(toUpdate[fiche.onglet].rows[fiche.ligne], 'colAddedToFiche', [])
  toUpdate[fiche.onglet].rows[fiche.ligne].colAddedToFiche = ['H1']
  return toUpdate
}

export const setRowId = (toUpdate, {onglet, ligne, id}) => {
  if (!toUpdate.rows) {
    toUpdate.rows = []
  }
  if (!toUpdate.rows[ligne]) {
    toUpdate.rows[ligne] = { id }
  } else {
    toUpdate.rows[ligne] = {
      id,
      ...toUpdate.rows[ligne]
    }
  }
  return toUpdate
}

export const setAddedToFiche = (tableau, payload) => {
  const { ligne, headerKey, value, erase } = payload
  if (!tableau.rows[ligne].colAddedToFiche) {
    Vue.set(tableau.rows[ligne], 'colAddedToFiche', [])
  }
  if (Array.isArray(headerKey)) {
    if (erase) {
      tableau.rows[ligne].colAddedToFiche = []
    }

    if (headerKey.length === 0) {
      return
    }

    headerKey.forEach(key => {
      if (key[0] === 'C') {
        if (headerKey === 'C56') {
          tableau.client.type = payload.valeur
        }

        if (headerKey === 'C57') {
          tableau.client.nom = payload.valeur
        }

        if (headerKey === 'C58') {
          tableau.client.adresse = payload.valeur
        }

        if (headerKey === 'C59') {
          tableau.client.complement_adresse = payload.valeur
        }

        if (headerKey === 'C60') {
          tableau.client.code_postal = payload.valeur
        }

        if (headerKey === 'C61') {
          tableau.client.ville = payload.valeur
        }

        if (headerKey === 'C62') {
          tableau.client.pays = payload.valeur
        }

        if (headerKey === 'C63') {
          tableau.client.nom_du_contact = payload.valeur
        }

        if (headerKey === 'C64') {
          tableau.client.prenom_du_contact = payload.valeur
        }

        if (headerKey === 'C65') {
          tableau.client.telephone = payload.valeur
        }

        if (headerKey === 'C66') {
          tableau.client.mobile = payload.valeur
        }

        if (headerKey === 'C67') {
          tableau.client.email1 = payload.valeur
        }

        if (headerKey === 'C68') {
          tableau.client.email2 = payload.valeur
        }
      } else if (key[0] === 'P') {

      } else {
        if (value) {
          tableau.rows[ligne].colAddedToFiche = [...tableau.rows[ligne].colAddedToFiche, key]
        } else {
          tableau.rows[ligne].colAddedToFiche = tableau.rows[ligne].colAddedToFiche.filter(el => el !== key)
        }
      }
    })
    return
  }
  if (value) {
    tableau.rows[ligne].colAddedToFiche = [...tableau.rows[ligne].colAddedToFiche, headerKey]
  } else {
    tableau.rows[ligne].colAddedToFiche = tableau.rows[ligne].colAddedToFiche.filter(el => el !== headerKey)
  }
}

export const setAddedToFicheTemplate = (fiche, payload) => {
  const { headerKey, value } = payload
  if (!fiche.data.colAddedToFiche) {
    Vue.set(fiche.data, 'colAddedToFiche', [])
  }
  if (Array.isArray(headerKey)) {
    if (headerKey.length === 0) {
      return
    }
    headerKey.forEach(key => {
      if (value) {
        fiche.data.colAddedToFiche = [...fiche.data.colAddedToFiche, key]
      } else {
        fiche.data.colAddedToFiche = fiche.data.colAddedToFiche.filter(el => el !== key)
      }
    })
    return
  }
  if (value) {
    fiche.data.colAddedToFiche = [...new Set([...fiche.data.colAddedToFiche, headerKey])]
  } else {
    fiche.data.colAddedToFiche = fiche.data.colAddedToFiche.filter(el => el !== headerKey)
  }
}

export const getHeaderKeysAddedToFiche = (row) => {
  return row.colAddedToFiche
}

export const getConteneurHeaderKeysAddedToFiche = (conteneur) => {
  const headerKeys = conteneur.childElements.map(col => {
    return getColonneHeaderKeysAddedToFiche(col)
  })
  return headerKeys.flat()
}

export const getDropHeaderKeysAddedToFiche = (drop) => {
  return drop.childElements.map(el => el.key)
}

export const getColonneHeaderKeysAddedToFiche = (colonne) => {
  let res = []
  colonne.childElements.forEach(el => {
    if (el.type === 'drop') {
      res = [...res, ...getDropHeaderKeysAddedToFiche(el)]
    }
  })
  return res
}

export const addAndRemoveDuplicate = (toUpdate, key, newData) => {
  if (Object.keys(toUpdate).includes(key)) {
    toUpdate[key] = newData
    return
  }
  Vue.set(toUpdate, key, newData)
}

export const getCoordFromKey = (columns, key) => {
  return columns.findIndex(el => el.key === key)
}

export const updateCellValue = (ftdata, payload) => {
  const {onglet, ligne, headerKey, valeur} = payload
  const newValue = ftdata.find(el => el.id + '' === onglet + '')
  const colCoord = getCoordFromKey(newValue.columns, headerKey)
  newValue.data[ligne][colCoord] = valeur
  return newValue
}



// WEBPACK FOOTER //
// ./src/store/modules/ficheEspace/utils.js